import React from 'react';
import classnames from 'classnames';

import styles from './IncrementDecrement.module.scss';

type IncrementDecrementT = {
  quantity?: number;
  customClass?: string;
  handleChange: (value: number, action?: 'increment' | 'decrement') => void;
  hasError?: boolean;
  minValue?: number;
};

function IncrementDecrement({
  quantity,
  customClass,
  handleChange,
  hasError,
  minValue = 0,
}: IncrementDecrementT) {
  const incrementDecrementClasses = classnames(styles.incrementDecrement, {
    [`${customClass}`]: customClass,
  });

  const incrementDecrementInputClasses = classnames(styles.incrementDecrement_input, {
    [styles.incrementDecrement_input__error]: hasError,
  });

  function isValidNumber(val: unknown): val is number {
    return typeof val === 'number' && !isNaN(val);
  }

  const isMinusDisabled = !quantity || quantity === 1 || minValue > (quantity || 0);

  return (
    <div className={incrementDecrementClasses}>
      <button
        onClick={() => handleChange(isValidNumber(quantity) ? quantity - 1 : 0, 'decrement')}
        className={classnames(styles.incrementDecrement_button, styles.button_minus, {
          [styles.incrementDecrement_button__disabled]: isMinusDisabled,
        })}
        disabled={isMinusDisabled}
      />
      <input
        type="number"
        onChange={(e) => {
          const val = e.target.value.replace(/^0+(\d)/, '$1');
          handleChange(val === '' ? NaN : Number(val));
        }}
        onBlur={(e) => {
          handleChange(Number(e.target.value) || 0);
        }}
        value={isValidNumber(quantity) ? quantity : ''}
        className={incrementDecrementInputClasses}
      />
      <button
        onClick={() => handleChange(isValidNumber(quantity) ? quantity + 1 : 1, 'increment')}
        className={classnames(styles.incrementDecrement_button, styles.button_plus)}
      />
    </div>
  );
}

export default IncrementDecrement;
